/* global jQuery */

import GA4Tracking from './utils/ga4-tracking'

export const handleOnClickViewItemListEvent = () => {
  jQuery(document).on('click', (e) => {
    addViewItemListOnPageLoad()
  })
}

export const addViewItemListOnPageLoad = () => {
  const gaViewItemLists = jQuery(':not([data-ga-vil-done])[data-ga-vil]')
  if (gaViewItemLists.length === 0) {
    return
  }

  gaViewItemLists.each((index, gaViewItemList) => {
    const gaViewItemListElement = jQuery(gaViewItemList)
    if (! gaViewItemListElement.is(':visible')) {
      return
    }

    gaViewItemListElement.attr('data-ga-vil-done', '')
    const gaItemElements = gaViewItemListElement.find('[data-ga-item]')
    if (gaItemElements.length === 0) {
      return
    }

    const gaDataAttr = gaViewItemListElement.attr('data-ga-data')
    const gaData = gaDataAttr !== undefined ? JSON.parse(gaDataAttr) : null
    if (typeof gaData !== 'object') {
      return
    }

    let gaItemIndex = gaData.hasOwnProperty('start_index') ? gaData.start_index : 0
    let items = []

    for (let i = 0; i < gaItemElements.length; i++) {
      const gaItemAttribute = jQuery(gaItemElements[i]).attr('data-ga-item')
      const gaItem = JSON.parse(gaItemAttribute)
      if (typeof gaItem !== 'object') {
        continue
      }

      gaItem.index = gaItemIndex
      gaItemIndex++

      items.push(gaItem)
    }

    GA4Tracking.pushEvent('view_item_list', items, gaData)
  })
}
